import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

// Attach JWT if present
api.interceptors.request.use((config) => {
    const token = typeof window !== "undefined" ? localStorage.getItem("boxeb2b_jwt") : null;
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});
